import React, { useEffect, useState } from 'react';
import { useSearchParams, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import Container from "@mui/material/Container";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@mui/material";

import { CityWithMap } from "./CityWithMap/cityWithMap";
import { CityWithoutMap } from "./CityWithoutMap/cityWithoutMap";
import { getProperties, getPropertiesForMap } from "../../../../../Requests/BasicRequests/basicRequests";
import { ModalWindowPhoneConfirmation } from "./ModalWindowPhoneConfirmation/modalWindowPhoneConfirmation";
import { getAmenities, getPropertyTypes } from "../../../../../Requests/CommonRequests/commonRequests"

export default function City(props) {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [searchParams] = useSearchParams();

    let { city } = useParams();

    useEffect(() => {
        let urlRequestParams = {
            ...Object.fromEntries([...searchParams]),
            status: 1
        }
        Object.keys(urlRequestParams).forEach(k => urlRequestParams[k] === 0 && delete urlRequestParams[k])

        Promise.all([
            getProperties(props, urlRequestParams), 
            getPropertiesForMap(props, urlRequestParams),
            getAmenities(props, ''),
            getPropertyTypes(props),
        ])
            .then(
                () => setIsLoaded(true),
                (error) => setError(error)
            )

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams])

    useEffect(() => {
        if (props.internalSystem.isAccessToRedirect) {
            props.internalSystemActions.setIsAccessToRedirect(false)
        }
    }, [])

    if (error || city !== 'brest') {
        throw new Error('404 Page Not Found');
    }

    const closeAlertPasswordReset = () => {
        props.internalSystemActions.setIsResetPassword(false)
    }

    const closeAlertPasswordRecovery = () => {
        props.internalSystemActions.setIsRecoveryPassword(false)
    }

    const closeAlertMailMessageWasSent = () => {
        props.internalSystemActions.setIsMailMessageWasSent(false)
    }

    return (
        <div>
            <Helmet>
                <title>Снять квартиру на сутки в Бресте, аренда квартиры посуточно Брест</title>
                <meta name="description" content="Квартира на сутки в Брест без посредников  Выгодные предложения на посуточные квартиры в Бресте  Удобная система выбора и аренды жилья в Бресте на сутки  Снять квартиру в Бресте на короткий срок в любом районе можно на нашем сайте"/>
                <link rel='canonical' href={`${(window.location.protocol === 'https:' ? process.env.REACT_APP_BASIC : process.env.REACT_APP_LOCAL_BASIC)}/${city}`}/>
            </Helmet>

            {props.internalSystem.isCityWithMap ? (
                <div>
                    <CityWithMap {...props} isLoaded={isLoaded} error={error} />
                </div>
            ) : (
                <Container maxWidth="lg">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <br/>
                    </div>
                    <CityWithoutMap {...props} isLoaded={isLoaded} error={error} permissions={props.user.permissions} />
                    <br/>
                </Container>
            )}

            <Snackbar open={props.internalSystem.isRecoveryPassword} autoHideDuration={6000} onClose={closeAlertPasswordRecovery} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={closeAlertPasswordRecovery} severity="success" sx={{ width: '100%' }}>
                    {'Ссылка для восстановления пароля была отправлена на вашу электронную почту.'}
                </Alert>
            </Snackbar>

            <Snackbar open={props.internalSystem.isResetPassword} autoHideDuration={6000} onClose={closeAlertPasswordReset} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={closeAlertPasswordReset} severity="success" sx={{ width: '100%' }}>
                    {'Новый пароль сохранен.'}
                </Alert>
            </Snackbar>

            <Snackbar open={props.internalSystem.isMailMessageWasSent} autoHideDuration={6000} onClose={closeAlertMailMessageWasSent} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={closeAlertMailMessageWasSent} severity="success" sx={{ width: '100%' }}>
                    {`На вашу почту ${props.user?.email} отправлено письмо. Перейдите по ссылке в письме для подтверждения своего e-mail`}
                </Alert>
            </Snackbar>

            <ModalWindowPhoneConfirmation {...props} />
        </div>
    );
}

